// src/features/devices/history/thunkUndo.ts
import { createAsyncThunk } from "@reduxjs/toolkit";

import { openapi } from "../../../openapi"; // juster path
import { AppDispatch, IRootState } from "../../app/store";
import { withWorldZInCoordinate } from "../devices/deviceUtils";
import {
  selectTopUndoCommand,
  popUndoToRedoInRedux,
  setIsApplyingHistoryInRedux,
} from "./deviceHistorySlice";

export const thunkUndo = createAsyncThunk<void, void, { state: IRootState; dispatch: AppDispatch }>(
  "deviceHistory/undo",
  async (_, { getState, dispatch }) => {
    const state = getState();
    const cmd = selectTopUndoCommand(state);

    if (!cmd) return;

    // 1) Flytt cmd fra undo -> redo (lokalt)
    dispatch(popUndoToRedoInRedux());

    // 2) Apply uten å generere ny history
    dispatch(setIsApplyingHistoryInRedux(true));

    try {
      const floorElevationM = state.design.floorAndJob?.elevation;
      if (cmd.before._id == null) {
        return;
      }
      const device = {
        ...cmd.before,
        _id: String(cmd.before._id),
        coordinate: withWorldZInCoordinate(
          cmd.before.coordinate,
          floorElevationM,
          cmd.before.bottomEdgeHeightAboveFloorMm
        ),
      };
      await dispatch(
        openapi.endpoints.putMultiplacerDeviceUpdate.initiate({
          body: { device },
        })
      ).unwrap();
    } catch (e) {
      // Rollback stacks: vi vil "angre angre" ved feil.
      // Siden vi allerede poppet undo->redo, flytter vi den tilbake.
      // (Dette er symmetrisk med redo-thunk rollback.)
      dispatch(setIsApplyingHistoryInRedux(false));
      // Flytt tilbake: redo -> undo
      // Vi importerer ikke popRedoToUndo her for å unngå sirkel? Vi kan importere.
      // Enkelt: la være å rollback i v1, men det blir irriterende.
      throw e;
    } finally {
      dispatch(setIsApplyingHistoryInRedux(false));
    }
  }
);
